
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/selling/shipping-and-delivery-process",
      function () {
        return require("private-next-pages/content/selling/shipping-and-delivery-process.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/selling/shipping-and-delivery-process"])
      });
    }
  